import { TourComponent } from '@/shared/components';
import { useResize } from '@/shared/utils';
import { SyncOutlined } from '@ant-design/icons';
import { FloatButton, Form, Select, Table } from 'antd';
import { useTMSMapTable } from './TMSMapTable.hooks';
import { useTour } from './useTour';
import { useEffect, useState } from 'react';

export const TMSMapTable = () => {
  const [data, setData] = useState([]);

  const { urlRef, mapTypesRef, steps, startTour, handleTourChange, handleClose, currentStep, isTourOpen } = useTour(
    data?.length
  );

  const {
    form,
    onFinish,
    loading,
    columns,
    dataMbtiles,
    selectedType,
    handleTypeChange,
    mapTypesWithoutHgt,
    paginationProps,
  } = useTMSMapTable({ urlRef });
  const { isMobile } = useResize();

  useEffect(() => {
    setData(dataMbtiles);
  }, [dataMbtiles]);

  return (
    <>
      <TourComponent
        handleClose={handleClose}
        handleOpen={startTour}
        onChange={handleTourChange}
        isTourOpen={isTourOpen}
        steps={steps}
        current={currentStep}
      />
      <div ref={mapTypesRef} style={{ width: 'fit-content' }}>
        <Select
          value={selectedType}
          placeholder='Выберите тип карт'
          options={mapTypesWithoutHgt}
          onChange={handleTypeChange}
          className='custom-select'
          style={{
            width: '250px',
            marginBottom: '2%',
          }}
        />
      </div>
      <Form form={form} onFinish={onFinish}>
        <Table
          loading={loading}
          columns={columns}
          dataSource={dataMbtiles}
          pagination={paginationProps}
          scroll={isMobile ? null : { x: 2500 }}
          bordered
        />
      </Form>
      {selectedType ? (
        <FloatButton icon={<SyncOutlined />} tooltip={`Очистить фильтр`} onClick={() => handleTypeChange(null)} />
      ) : null}
    </>
  );
};
